module.exports = __webpack_public_path__ + "img/advice.bcf98e19.png";